import { type RouteObject } from 'react-router';

import { metadataRoute, pushRoute } from '@@components/Page/detailViewRoutes';
import { ErrorPage } from '@@containers/App/ErrorPage';

export const routes: RouteObject[] = [
    {
        index: true,
        lazy: async () => {
            const ArticleList = (await import('@@routes/articles/ArticleList')).default;

            return { Component: ArticleList };
        },
    },
    {
        path: 'new',
        lazy: async () => {
            const { ArticleSetupPage } = await import('@@routes/articles');

            return { Component: ArticleSetupPage };
        },
    },
    {
        path: ':id',
        lazy: async () => {
            const { ArticleDetailPage } = await import('@@routes/articles');

            return { Component: ArticleDetailPage };
        },
        children: [
            {
                index: true,
                lazy: async () => {
                    const { default: ArticleContent } =
                        await import('@@routes/articles/ArticleContent');

                    return { Component: ArticleContent };
                },
                errorElement: <ErrorPage />,
            },
            {
                path: 'revisions/:revisionId',
                lazy: async () => {
                    const { default: UnityArticleRevision } =
                        await import('@@routes/articles/articleViews/UnityArticle/UnityArticleRevision');

                    return { Component: UnityArticleRevision };
                },
                errorElement: <ErrorPage />,
            },
            metadataRoute,
            pushRoute,
        ],
    },
];
